









































import { Component, Prop, Mixins, Inject } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import { IOAuthToken } from "@/models/oauth";
import HasValidation from "@/mixins/HasValidation";
import { ValidationObserver } from "vee-validate";
import { IOAuthProviderMethods } from "@/models/providers/oauth";

@Component
export default class EditOAuthTokenModal extends Mixins(
  RequestPromises,
  HasValidation
) {
  // Inject
  @Inject({ from: "oauthProviderMethods" })
  public readonly $methods!: IOAuthProviderMethods;

  // Props
  @Prop({ required: true })
  public token!: IOAuthToken;

  // Data
  public isProcessing = false;
  public form = {
    name: this.token.name
  };
  // Refs
  public $refs!: {
    name: HTMLFormElement;
    observer: InstanceType<typeof ValidationObserver>;
  };

  public mounted() {
    this.$nextTick(() => {
      if (!this.$refs.name) {
        return;
      }
      this.$refs.name.focus();
    });
  }

  public async validateBeforeSubmit() {
    this.isProcessing = true;
    try {
      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }
      await this.$methods.updateOAuthToken({
        uuid: this.token.uuid,
        data: {
          name: this.form.name
        }
      });
      this.$emit("success");
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    }
    this.isProcessing = false;
  }
}
